import React from 'react';
import { Navigate, Outlet } from 'react-router';

// Simple check for valid JWT format (header.payload.signature)
const isValidToken = (token) => {
    if (!token) return false;
    const parts = token.split('.');
    return parts.length === 3;
};

const PrivateRoute = () => {
    const token = localStorage.getItem("token");

    if (!token || !isValidToken(token)) {
        // If there's an invalid token, clear it to prevent infinite loops/confusion
        if (token) localStorage.removeItem("token");
        return <Navigate to="/" />;
    }

    return <Outlet />;
};

export default PrivateRoute;
